import type {Gateway} from '../../types';
import type {BindingSource, BindingContext} from '../../primitives';

import {getExpandedBindingSources} from './getBindingSources';

export class BindingSourceIndex {
  #bindingSourceIndex: Readonly<{
    [key: string]: BindingSource;
  }>;

  constructor(bindingContext: BindingContext, gateways: Gateway[]) {
    const index: {
      [key: string]: BindingSource;
    } = {};
    const expandedBindingSources = getExpandedBindingSources(
      bindingContext.type,
      gateways,
      true // include deprecated binding sources
    );

    for (const bindingSource of expandedBindingSources) {
      index[getBindingPathKey(bindingSource)] = bindingSource;
    }

    this.#bindingSourceIndex = index;
  }

  getBindingSource(bindingPath: ReadonlyArray<string>): BindingSource | null {
    const key = toBindingPathKey(bindingPath);
    return this.#bindingSourceIndex[key] ?? null;
  }
}

function getBindingPathKey(source: BindingSource): string {
  return toBindingPathKey(source.path.map((part) => part.slug));
}

function toBindingPathKey(bindingPath: ReadonlyArray<string>): string {
  return bindingPath.join('.');
}
